module.exports = __webpack_public_path__ + "static/media/pass-out-return-icon.b7c62326.svg";